import React from 'react'
import moment from 'moment'

const Age = (dobDate, atTime) => {
  const dob = moment(dobDate)
  const at = atTime ? moment(atTime) : moment()

  const years = at.diff(dob, 'years')
  const months = at.diff(dob.clone().add(years, 'years'), 'months')

  if (years >= 12) return `${years} years`
  if (years === 0) return `${months} months`
  if (!years && !months) return 'Unknown'
  return `${years} years, ${months} months`
}

export default Age
